import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const PLACES_LEFT_THRESHOLD = 8;

const Hint = ({ isSoldOut, spots }) => {
  if (isSoldOut) {
    if (spots === 0) {
      return (
        <span className="hint sold-out">
          <FormattedMessage id="SOLD_OUT" defaultMessage="Sold out" />
        </span>
      );
    }
    return (
      <span className="hint sold-out">
        <FormattedMessage
          id="SPOTS_COUNT"
          defaultMessage="{count, plural, one {# spot} other {# spots}}"
          values={{ count: spots }}
        />
      </span>
    );
  }

  if (spots <= PLACES_LEFT_THRESHOLD) {
    return (
      <span className="hint">
        <FormattedMessage
          id="SPOTS_COUNT"
          defaultMessage="{count, plural, one {# spot} other {# spots}}"
          values={{ count: spots }}
        />
      </span>
    );
  }

  return null;
};

Hint.displayName = 'BookingRequest-Times-Hint';

Hint.propTypes = {
  spots: PropTypes.number.isRequired,
  isSoldOut: PropTypes.bool,
};

Hint.defaultProps = {
  isSoldOut: false,
};

export default Hint;
